import { getInitialState } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  driverStoriesList: [],
  prevPage: -1,
  nextPage: -1,
  activeCampaignDetails: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.RESET_STATE:
      return resetState(state, action);
    case ActionTypes.SET_STORIES_LIST:
      return setStoriesList(state, action);
    case ActionTypes.SET_ACTIVE_STORY_CAMPAIGN:
      return setActiveCampaign(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION:
      return setActiveFilters(state, action);
    default:
      return state;
  }
}

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveCampaign = (state, action) => {
  return {
    ...state,
    activeCampaignDetails: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setStoriesList = (state, action) => {
  return {
    ...state,
    driverStoriesList: [...(action.payload?.stories || [])],
    prevPage: action.payload?.page_response?.previousPage,
    nextPage: action.payload?.page_response?.nextPage,
  };
};
